module.exports = __webpack_public_path__ + "aab7df83dc11ae39720642e9f2d51813.svg";